import React from "react";
import useAdditionalInformation from "../../hooks/useAdditionalInformation";
import { ConfigurationRenderProps } from "../StrikeZoneRender";
import InformationContainer from "./InformationContainer";

const getPrimary = (primary: string, primaryLabel: string): string => {
  if (primaryLabel === "Exit Velocity") {
    return `EV: ${primary}`;
  } else {
    return primary;
  }
};

const AdditionalInformation: React.FC<ConfigurationRenderProps> = ({ config }) => {
  const { primary, primaryLabel, secondary } = useAdditionalInformation(config);
  return <InformationContainer left={getPrimary(primary, primaryLabel)} right={secondary} config={config} />;
};

export default AdditionalInformation;
